/**
 * --------------------------------------------------
 * Marketo 3rd party integration
 * 
 * @module marketo
 * @see module:marketo
 * --------------------------------------------------
 */

import Forms from './forms';
import EmailInput from './email-input.js';

export default {

    selectedClassName: 'selected',
    dirtyClassName: 'isDirty',
    arrayFrom: Function.prototype.call.bind(Array.prototype.slice),
    $formElem: '.rt-js-marketo-form',
    $marketoId: null,
    $marketoUrl: null,
    $marketoFormId: [],

    setup: function () {
        // Initialize Marketo forms
        this.$marketoId = $('meta[name="marketo-id"]').attr('content');
        this.$marketoUrl = "//" + $('meta[name="marketo-url"]').attr('content');

        // Get all form elements
        const $forms = $(this.$formElem);

        // Loop through all the elements
        for (let i = 0; i < $forms.length; i++) {
            const $form = $forms.eq(i);
            const formId = $form.data('formid');
            this.$marketoFormId[i] = formId;

            // Initialize Marketo form if ID is present
            if (formId) {
                this.marketo(formId);
            }
        }
    },


    marketo: function ($id) {
        const _self = this;

        // Validate if MktoForms2 is loaded and $id is defined
        if(window.MktoForms2 && $id){
            // load form
            MktoForms2.loadForm(_self.$marketoUrl, _self.$marketoId, $id, function(form) {

                // Validate if form is not null
                if(form){

                    const $formElem = $('#mktoForm_' + $id);

                    //Remove loading message, if there is one
                    $formElem.find('.marketo-loading').remove();

                    // Remove default styles
                    _self._destyleMktoForm(form);

                    // Re-destyle conditional fields when they appear (lazy: only after first focus)
                    _self._observeFormChanges(form);

                    // Add accesibility features
                    _self._addAccesibilityFeatures(form);

                    // Adding events
                    Forms.find('.input');

                    // Initialize email input module
                    EmailInput.setup();

                    // Submit form
                    _self._submitForm($id, form, false); // Production
                    // _self._submitForm($id, form, true); // Testing
                }
            });
        }
    },

    // Attach a MutationObserver only after the first focusin so it doesn't run while the form is idle.
    // Handles conditional fields that Marketo reveals via visibility rules (re-injects inline styles).
    _observeFormChanges: function(form) {
        const _self = this;
        const formElem = form.getFormElem()[0];

        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                // Destyle and classify newly inserted nodes or revealed fields (style attr change)
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach(function(node) {
                        if (node.nodeType === 1) {
                            _self._destyleMktoForm(form);
                            // Classify and tag newly injected field wraps
                            $(node).find('.mktoFieldWrap').each(function() {
                                const $wrap = $(this);
                                const classes = _self._classifyFieldWrap($wrap, formElem);
                                $wrap.addClass(classes);
                                // If it's a plain input (not radio/checkbox), also mark as conditional
                                if (classes === 'input') {
                                    $wrap.addClass('rt-conditional-field');
                                }
                            });
                        }
                    });
                } else if (mutation.type === 'attributes') {
                    _self._destyleMktoForm(form);
                }
            });
        });

        // Start observing only on first user interaction
        $(formElem).one('focusin', function() {
            observer.observe(formElem, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: ['style']
            });
        });
    },

    // Remove default style tags from Marketo form
   _removeFormStyles: function (aForm){
        var styledEls = this.arrayFrom(aForm.querySelectorAll("[style]")).concat(aForm);
        for (var i = 0; i < styledEls.length; i++) {
            styledEls[i].removeAttribute("style");
        }
    },

    // Remove default styles from Marketo form
    _destyleMktoForm: function (form) {

        const _self = this;
        const $form = $(this.$formElem);

        // Validate if form is null
        if (form === null) {
            $form.parent().css('display', 'none');

        } else {
            const formElem = form.getFormElem()[0];
    
            // remove element styles from <form> and children
            _self._removeFormStyles(formElem);
    
            // disable remote stylesheets and local <style>s
            let styleSheets = this.arrayFrom(document.styleSheets);
            for(let i = 0; i < styleSheets.length; i++) {
                if ( [mktoForms2BaseStyle,mktoForms2ThemeStyle].indexOf(styleSheets[i].ownerNode) != -1 || formElem.contains(styleSheets[i].ownerNode) ) {
                    styleSheets[i].disabled = true;
                }
            }
    
            // Adding our own .input class
            _self._addInputClass(formElem);
        }
    },

    _addInputClass: function(formElem) {
        const _self = this;
        $(formElem).find('.mktoFieldWrap').each(function() {
            const $fieldWrap = $(this);
            $fieldWrap.addClass(_self._classifyFieldWrap($fieldWrap, formElem));
        });
    },

    // Returns the appropriate class string for a given field wrap.
    // Centralised here so changes to form variants only need updating in one place.
    _classifyFieldWrap: function($fieldWrap, formElem) {
        if ($fieldWrap.has('input[type="radio"]').length > 0)    return 'rt-radio-wrap';
        if ($fieldWrap.has('input[type="checkbox"]').length > 0) return 'rt-checkbox-wrap';
        if ($fieldWrap.has('select').length > 0)                 return 'input';

        return 'input';
    },

    // Add accesibility features to Marketo forms
    _addAccesibilityFeatures: function (form) {
        const formEl = form.getFormElem()[0];
        const formFields = $(formEl).find('.mktoField');
        const formLabels = $(formEl).find('label[id^="LblmktoCheckbox"]'); // Add only to checkboxes
        const formButtons = $(formEl).find('.mktoButton');

       // Get all the fields, labels, and buttons
        let elements = Array.from(formFields).concat(Array.from(formLabels), Array.from(formButtons));

        // Loop over all the elements and set the attribute
        elements.forEach(function(element) {
            element.setAttribute('tabindex', '0');
        });
    },

    // Helper function for testing purposes
    _submitForm: function($id, form, $test) {
        const $formElem = $('#mktoForm_' + $id);
        const $formContainer = $('#form_' + $id);
        const $formComplete = $('#form-completed_' + $id);
        const _scroll = $formElem.data('scroll') ? $formElem.data('scroll') : true;
        const _self = this;

        // Validate if test or production
        if($test === true) {
            $formElem.on('submit', function(e) {
                e.preventDefault(); // Prevent actual submission

                // Hide form and show thank you message
                _self._hideShowForm($formContainer, $formComplete, _scroll);

                // Optionally, return false to stop Marketo
                return false;
            });
        } else {
            // Add an onSuccess handler that show the "thank you" div
            form.onSuccess(function () {

                // Hide form and show thank you message
                _self._hideShowForm($formContainer, $formComplete, _scroll);
                
                // Optionally, return false to stop Marketo
                return false;
            });
        }
    },

    // Helper function to hide/show form and thank you message
    _hideShowForm: function($formContainer, $formComplete, scroll) {

        // Hide form and show thank you message
        $formContainer.addClass('is-hidden');
        $formComplete.removeClass('is-hidden');

        // Validate is scroll is true
        if(scroll) {
            // Scrolling back to top to show the Thank you message in resources pages
            $('html, body').animate({
                scrollTop: $formComplete.offset().top - 100
            }, 500);
        }
    }
};